/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-fund-by-broker-manual',
  template: require('./fund-by-broker-manual.component.html')
})

export class FundByBrokerManualComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  difFundingMethod(event) {
    this.modal.difFunding();
  }

  fundLater() {
    this.flowManager.fundLaterRouting();
  }
}
